<template>
<div>
	<div class="btn-group btn-group shadow-0 mt-5" role="group">
		<button
			type="button"
			class="btn btn-info"
			@click="setActive('global')"
			:class="{ active: isActive === 'global',}"
			data-bs-color="dark"
		>
			Global
		</button>
		<button
			:disabled="!isAuth || getLeague === 'No League'"
			type="button"
			class="btn btn-info"
			@click="setActive('league')"
			:class="{ active: isActive === 'league',}"
			data-bs-color="dark"
		>
			League
		</button>
		<button
			:disabled="!isAuth || getTeam === ''"
			type="button"
			class="btn btn-info"
			@click="setActive('team')"
			:class="{ active: isActive === 'team',}"
			data-bs-color="dark"
		>
			Team
		</button>
	</div>
	<div v-if="isActive === 'global'" class="mt-5">
		<global-board @component-key="componentKey" :key="keyPlus"></global-board>
	</div>
	<div v-if="isActive === 'league'" class="mt-5">
		<league-board :key="keyPlus"></league-board>
	</div>
	<div v-if="isActive === 'team'" class="mt-5">
		<team-board :key="keyPlus"></team-board>
	</div>
</div>
</template>

<script>
import GlobalBoard from '@/components/boards/GlobalBoard.vue';
import LeagueBoard from '@/components/boards/LeagueBoard.vue';
import TeamBoard from '@/components/boards/TeamBoard.vue';

export default {
	components: {
		GlobalBoard,
		LeagueBoard,
		TeamBoard,
	},
	data() {
		return {
			isActive: 'global',
			keyPlus: 0,
			isLoading: false,
		};
	},
	computed: {
		isAuth() {
			return this.$store.getters.isAuthenticated;
		},
		getLeague() {
			return this.$store.getters.userLeague
		},
		getTeam() {
			return this.$store.getters.userTeam
		},
		getComponentKey() {
			return this.$store.getters.getUpdateComponent
		}
	},
	methods: {
		componentKey(payload) {
			setTimeout(() => {
				this.keyPlus += payload;
				this.$router.go()
			}, 1000);
		},
		setActive(btn) {
			this.isActive = btn;
		},
	},
};
</script>

<style scoped>
h1 {
	color: #39c0ed !important;
}
.active {
	border: 4px solid #37474F;
}
</style>
